import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/descuentos-devoluciones-ahorros';

/**
 * GET Retiros De Ahorros
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRetirosDeAhorros = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Retiro De Ahorro
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getRetiroDeAhorro = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Retiro De Ahorro
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRetiroDeAhorro = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Retiro De Ahorro
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRetiroDeAhorro = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Retiro De Ahorro
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteRetiroDeAhorro = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
